import { FC, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { adminService } from '@/services/admin.service';

interface Stats {
  publishedTrails: number;
  draftTrails: number;
  totalTags: number;
  totalBadges: number;
}

const AdminDashboardPage: FC = () => {
  const [stats, setStats] = useState<Stats>({ publishedTrails: 0, draftTrails: 0, totalTags: 0, totalBadges: 0 });
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const [trails, tags, badges] = await Promise.all([
          adminService.getTrails(),
          adminService.getTags(),
          adminService.getBadges(),
        ]);
        setStats({
          publishedTrails: trails.filter((t) => t.is_published).length,
          draftTrails: trails.filter((t) => !t.is_published).length,
          totalTags: tags.length,
          totalBadges: badges.length,
        });
      } catch {
        // silently fail — show zeros
      } finally {
        setIsLoading(false);
      }
    };
    load();
  }, []);

  const cards = [
    { label: 'Cursos Publicados', value: stats.publishedTrails, icon: 'check_circle', color: 'text-green-400', link: '/admin/cursos' },
    { label: 'Rascunhos', value: stats.draftTrails, icon: 'edit_note', color: 'text-yellow-400', link: '/admin/cursos' },
    { label: 'Tags', value: stats.totalTags, icon: 'label', color: 'text-blue-400', link: '/admin/tags' },
    { label: 'Badges', value: stats.totalBadges, icon: 'military_tech', color: 'text-purple-400', link: '/admin/badges' },
  ];

  return (
    <div className="p-6 lg:p-10">
      <h1 className="text-2xl font-bold mb-8">Dashboard Admin</h1>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {cards.map((card) => (
          <Link
            key={card.label}
            to={card.link}
            className="bg-surface-card border border-theme-border rounded-xl p-6 hover:border-accent/40 transition-all"
          >
            <div className="flex items-center gap-4">
              <span className={`material-symbols-outlined text-3xl ${card.color}`}>{card.icon}</span>
              <div>
                <p className="text-2xl font-bold">{isLoading ? '—' : card.value}</p>
                <p className="text-content-muted text-sm">{card.label}</p>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default AdminDashboardPage;
